import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  smallcapsBold13Styles,
  smallcapsBold14Styles,
} from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

import AnimatedDash, { animationStyles } from "../common/AnimatedDash"

const GatsbyLink = styled(({ linkStyles, ...props }) => (
  <Link {...props} />
))<any>`
  ${({ linkStyles }) => (linkStyles ? linkStyles : "")}
`

const Button = styled.span<any>`
  ${smallcapsBold13Styles}
  display: flex;
  position: relative;
  width: 100%;
  height: 48px;
  padding: 0 24px;
  align-items: center;
  justify-content: space-between;
  color: ${colors.black};
  background-color: transparent;
  border-radius: 2px;
  border: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${animationStyles}

  @media ${breakpoints.laptop} {
    ${smallcapsBold14Styles}
    color: ${colors.black};
  }

  ${({ buttonStyles }) => (buttonStyles ? buttonStyles : "")}
`

const Text = styled.span`
  margin-right: 24px;
  padding-top: 3px;
`

interface IProps {
  buttonStyles?: string
  className?: string
  text: string
  to: string
}

const FlatLinkButton = ({ buttonStyles, className, text, to }: IProps) => (
  <GatsbyLink className={className} to={to || ""}>
    <Button buttonStyles={buttonStyles}>
      <Text>{text}</Text>
      <AnimatedDash color={colors.black} />
    </Button>
  </GatsbyLink>
)

export default FlatLinkButton
